export const SLIDE_META = {
  multiple_choice: { label: "Multiple Choice", icon: "BarChart3", color: "#6366F1", desc: "Poll with options and a live bar chart" },
  word_cloud: { label: "Word Cloud", icon: "Cloud", color: "#06B6D4", desc: "Words grow as they are repeated" },
  open_ended: { label: "Open Ended", icon: "MessageSquare", color: "#EC4899", desc: "Collect free-text responses as cards" },
  scales: { label: "Scales / Rating", icon: "SlidersHorizontal", color: "#10B981", desc: "Rate statements on a numeric scale" },
  ranking: { label: "Ranking", icon: "ListOrdered", color: "#F59E0B", desc: "Order items by preference" },
  qa: { label: "Q&A", icon: "MessagesSquare", color: "#8B5CF6", desc: "Audience questions with upvoting" },
  quiz: { label: "Quiz", icon: "Trophy", color: "#F43F5E", desc: "Timed question with points & a live leaderboard" },
};

export const SLIDE_ORDER = ["multiple_choice", "word_cloud", "open_ended", "scales", "ranking", "qa", "quiz"];

export const CHART_COLORS = ["#6366F1", "#06B6D4", "#EC4899", "#10B981", "#F59E0B", "#8B5CF6", "#F43F5E", "#3B82F6"];
export const WORD_COLORS = ["#4F46E5", "#0284C7", "#DB2777", "#059669", "#D97706", "#7C3AED", "#E11D48"];

export function newId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function defaultSlide(type) {
  const base = {
    id: newId(),
    type,
    question: SLIDE_META[type].label,
    options: [],
    scale_min: 1,
    scale_max: 5,
    scale_min_label: "Strongly disagree",
    scale_max_label: "Strongly agree",
  };
  if (type === "multiple_choice") {
    base.question = "Which option do you prefer?";
    base.options = ["Option 1", "Option 2", "Option 3"];
  } else if (type === "ranking") {
    base.question = "Rank these in order of importance";
    base.options = ["Item A", "Item B", "Item C"];
  } else if (type === "word_cloud") {
    base.question = "Describe today in one word";
  } else if (type === "open_ended") {
    base.question = "What's on your mind?";
  } else if (type === "scales") {
    base.question = "How much do you agree?";
  } else if (type === "qa") {
    base.question = "Ask me anything";
  } else if (type === "quiz") {
    base.question = "Which answer is correct?";
    base.options = ["Answer 1", "Answer 2", "Answer 3", "Answer 4"];
    base.correct_option = 0;
    base.time_limit = 20;
  }
  return base;
}
